import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { AppLoginContainerModel } from '../../../../../models/aggregates/id';
import {app_login_subject_RowClass} from '../../../../../models/dbschema/app_login_subject.model'
import { Observable } from 'rxjs';
import {ApiResponseModel, ApiVisa, BasicApiResponseModel, Pagination, PagingResponseModel} from '../shared';

export class UserEmailRespond {
  email: string[];
}


@Injectable({
  providedIn: 'root'
})
export class TenantUserService extends BaseApiTemplateService<AppLoginContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'users';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'users';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'users';
    this.httpClient = http;
  }

  /** File Attachment related */
  public addUser(value: string, body: any, visa: ApiVisa) {
    let url = this.apiUrl + '?type=EMAIL_USERNAME&value=' + value;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '?type=EMAIL_USERNAME&value=' + value;
    }
    return this.httpClient.post<ApiResponseModel<app_login_subject_RowClass>>(url, body, this.getHttpHeader(visa));

  }

  public addUserAsSysadmin(value: string, body: any, visa: ApiVisa) {
    let url = this.apiUrl + '/sysadmin-ep?type=EMAIL_USERNAME&value=' + value;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/sysadmin-ep?type=EMAIL_USERNAME&value=' + value;
    }
    return this.httpClient.post<ApiResponseModel<app_login_subject_RowClass>>(url, body, this.getHttpHeader(visa));

  }

  public validateUserAsSysadmin(type: string, value: string, body: any, visa: ApiVisa) {
    let url = this.apiUrl + '/sysadmin-ep?type=' + type + '&value=' + value;

    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path + '/sysadmin-ep?type=' + type + '&value=' + value;
    }
    return this.httpClient.post<ApiResponseModel<app_login_subject_RowClass>>(url, body, this.getHttpHeader(visa));
  }

  getByCriteriaAsTenantAdmin(pagination: Pagination, apiVisa: ApiVisa): Observable<PagingResponseModel<AppLoginContainerModel>> {
    this.apiUrl = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'iam/app-login/login-tenant-ep/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<AppLoginContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(apiVisa)
    );
  }

  getByGuidAsTenantAdmin(guid: String, apiVisa: ApiVisa): Observable<BasicApiResponseModel<AppLoginContainerModel>> {
    this.apiUrl = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'iam/app-login/login-tenant-ep/' + guid;
    return this.httpClient.get<BasicApiResponseModel<AppLoginContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(apiVisa)
    );
  }

  searchByUserEmail(searchWord: string, apiVisa: ApiVisa): Observable<BasicApiResponseModel<UserEmailRespond>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/users/custom/login-principals/emails?search_word=' + searchWord;
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/users/custom/login-principals/emails?search_word=' + searchWord;
    }
    return this.httpClient.get<BasicApiResponseModel<UserEmailRespond>>(apiUrl, this.getHttpHeader(apiVisa));
  }

    searchByUserID(searchWord: string, apiVisa: ApiVisa): Observable<BasicApiResponseModel<UserEmailRespond>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/users/custom/login-principals/ids?search_word=' + searchWord;
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/users/custom/login-principals/ids?search_word=' + searchWord;
    }
    return this.httpClient.get<BasicApiResponseModel<UserEmailRespond>>(apiUrl, this.getHttpHeader(apiVisa));
  }

  // /core2/tnt/dm/iam/app-login/custom-return-roles/login-tenant-ep/query?
  getByCriteriaAsTenantAdminCustomRoles(pagination: Pagination, apiVisa: ApiVisa): Observable<PagingResponseModel<any>> {
    this.apiUrl = apiVisa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'iam/app-login/custom-return-roles/login-tenant-ep/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      this.apiUrl,
      this.getHttpHeader(apiVisa)
    );
  }
}
